// extracted by mini-css-extract-plugin
module.exports = {"main-component":"knownFor_main-component__1-Xyb"};